(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kinahh-category-circles"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kinahh-category-circles')) {
    customElements.define('kinahh-category-circles', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const { signal } = this.controller;
        this.list = this.querySelector('.kinahh-categories__list');
        this.buttons = [...this.querySelectorAll('[data-step]')];
        this.update = () => {
          const maximum = this.list.scrollWidth - this.list.clientWidth;
          const current = Math.abs(this.list.scrollLeft);
          for (const button of this.buttons) {
            button.hidden = maximum < 2;
            button.disabled = Number(button.dataset.step) < 0 ? current < 2 : current > maximum - 2;
          }
        };
        this.buttons.forEach(button => button.addEventListener('click', () => {
          const item = this.list.firstElementChild;
          if (!item) return;
          const gap = parseFloat(getComputedStyle(this.list).columnGap) || 0;
          const direction = getComputedStyle(this.list).direction === 'rtl' ? -1 : 1;
          this.list.scrollBy({ left: (item.getBoundingClientRect().width + gap) * Number(button.dataset.step) * direction, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        }, { signal }));
        this.list.addEventListener('scroll', this.update, { passive: true, signal });
        this.addEventListener('shopify:block:select', event => {
          const item = event.target.closest('.kinahh-categories__item');
          item?.scrollIntoView({ behavior: 'instant', block: 'nearest', inline: 'nearest' });
        }, { signal });
        this.observer = new ResizeObserver(this.update);
        this.observer.observe(this.list);
        this.update();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kinahh-hero-video"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kinahh-hero-video')) {
    class KinahhHeroVideo extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        this.toggle = this.querySelector('button');
        if (!this.video || !this.toggle) return;

        this.abortController = new AbortController();
        const signal = this.abortController.signal;
        this.mobile = matchMedia('(max-width: 749px)');
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.connection = navigator.connection;
        this.userPaused = false;
        this.userStarted = false;
        this.visible = false;
        this.playPending = false;
        this.resyncNeeded = false;
        this.originalFailed = false;
        this.video.muted = true;
        this.toggle.hidden = false;

        this.toggle.addEventListener('click', () => {
          if (!this.video.paused || this.playPending) {
            this.userPaused = true;
            this.userStarted = false;
            this.video.pause();
            this.updateControl();
          } else {
            this.userPaused = false;
            this.userStarted = true;
            this.play();
          }
        }, { signal });

        this.video.addEventListener('playing', () => {
          this.setAttribute('data-ready', '');
          this.updateControl();
        }, { signal });
        this.video.addEventListener('pause', () => this.updateControl(), { signal });
        this.video.addEventListener('error', () => {
          this.removeAttribute('data-ready');
          this.updateControl();
          if (!this.originalFailed && this.video.currentSrc === this.originalSource) {
            this.originalFailed = true;
            this.sync();
          }
        }, { signal });
        document.addEventListener('visibilitychange', () => this.sync(), { signal });
        this.motion.addEventListener('change', () => {
          this.userStarted = false;
          this.sync();
        }, { signal });
        this.connection?.addEventListener('change', () => this.sync(), { signal });
        this.mobile.addEventListener('change', () => {
          this.video.pause();
          this.removeAttribute('data-ready');
          this.sync();
        }, { signal });

        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          this.sync();
        }, { threshold: 0.05 });
        this.observer.observe(this);
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.observer?.disconnect();
        if (this.video) {
          this.video.pause();
          this.video.removeAttribute('src');
          this.video.load();
          this.removeAttribute('data-ready');
          this.removeAttribute('data-playing');
        }
      }

      source() {
        const template = this.querySelector(this.mobile.matches ? '[data-video-mobile]' : '[data-video-desktop]');
        const sources = [...template.content.querySelectorAll('source')];
        const original = sources.find(source => source.hasAttribute('data-original'));
        this.originalSource = original?.dataset.src;
        if (original && !this.originalFailed) return this.originalSource;
        const mp4 = sources.filter(source => source.type === 'video/mp4' && !source.hasAttribute('data-original')).sort((a, b) => Number(a.dataset.height) - Number(b.dataset.height));
        const selected = mp4.at(-1);
        const adaptive = sources.find(source => source.type.toLowerCase().includes('mpegurl') && this.video.canPlayType(source.type));
        return (selected || adaptive || sources[0])?.dataset.src;
      }

      allowed() {
        return this.userStarted || (!this.motion.matches && !this.connection?.saveData);
      }

      sync() {
        if (this.playPending) this.resyncNeeded = true;
        if (!this.visible || document.hidden || this.userPaused || !this.allowed()) {
          this.video.pause();
          return;
        }
        this.play();
      }

      async play() {
        if (this.playPending || !this.isConnected) return;
        const source = this.source();
        if (!source) return;
        if (this.video.getAttribute('src') !== source) {
          this.video.src = source;
          this.video.load();
        }
        this.playPending = true;
        try {
          await this.video.play();
          if (!this.isConnected || document.hidden || this.userPaused || !this.visible || !this.allowed()) this.video.pause();
        } catch {
          this.updateControl();
        } finally {
          this.playPending = false;
          if (this.resyncNeeded && this.isConnected) {
            this.resyncNeeded = false;
            this.sync();
          }
        }
      }

      updateControl() {
        const playing = !this.video.paused && !this.video.error;
        this.toggleAttribute('data-playing', playing);
        this.toggle.setAttribute('aria-label', playing ? this.toggle.dataset.pauseLabel : this.toggle.dataset.playLabel);
      }
    }
    customElements.define('kinahh-hero-video', KinahhHeroVideo);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kinahh-video-edit"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kinahh-video-edit')) {
    customElements.define('kinahh-video-edit', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.visibility?.disconnect();
        this.resize?.disconnect();
        this.controller = new AbortController();
        const { signal } = this.controller;
        this.list = this.querySelector('.kinahh-video-edit__list');
        this.cards = [...this.querySelectorAll('.kinahh-video-edit__card')];
        this.arrows = [...this.querySelectorAll('[data-step]')];
        this.cards.forEach(card => {
          const video = card.querySelector('video');
          const button = card.querySelector('.kinahh-video-edit__play');
          const error = card.querySelector('.kinahh-video-edit__error');
          card.wantsPlayback = false;
          button.hidden = false;
          button.addEventListener('click', () => {
            if (card.wantsPlayback || !video.paused) { this.pause(card); return; }
            this.cards.forEach(other => { if (other !== card) this.pause(other); });
            error.hidden = true;
            card.wantsPlayback = true;
            const request = card.playRequest = (card.playRequest || 0) + 1;
            video.muted = true;
            if (!video.getAttribute('src')) video.src = video.dataset.src;
            else if (video.error) video.load();
            video.play().then(() => {
              if (request !== card.playRequest) return;
              if (!card.wantsPlayback || !this.isConnected || document.hidden) this.pause(card);
            }).catch(() => {
              if (!card.wantsPlayback || request !== card.playRequest) return;
              this.pause(card);
              error.hidden = false;
            });
          }, { signal });
          video.addEventListener('playing', () => {
            if (!card.wantsPlayback) { video.pause(); return; }
            card.setAttribute('data-started', '');
            card.setAttribute('data-playing', '');
            button.setAttribute('aria-label', button.dataset.pauseLabel);
          }, { signal });
          video.addEventListener('pause', () => {
            if (!video.paused) return;
            card.wantsPlayback = false;
            card.removeAttribute('data-playing');
            button.setAttribute('aria-label', button.dataset.playLabel);
          }, { signal });
          video.addEventListener('error', () => {
            this.pause(card);
            card.removeAttribute('data-started');
            error.hidden = false;
          }, { signal });
        });
        this.update = () => {
          const { maximum, current } = this.scrollPosition();
          this.arrows.forEach(button => {
            button.hidden = maximum < 2;
            button.disabled = Number(button.dataset.step) < 0 ? current < 2 : current > maximum - 2;
          });
        };
        this.arrows.forEach(button => button.addEventListener('click', () => {
          const card = this.list.firstElementChild;
          if (!card) return;
          const gap = parseFloat(getComputedStyle(this.list).columnGap) || 0;
          const { maximum, current, direction } = this.scrollPosition();
          const target = Math.min(maximum, Math.max(0, current + (card.getBoundingClientRect().width + gap) * Number(button.dataset.step)));
          this.list.scrollTo({ left: target * direction, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        }, { signal }));
        this.list.addEventListener('scroll', this.update, { passive: true, signal });
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.cards.forEach(card => this.pause(card));
        }, { signal });
        this.addEventListener('shopify:block:select', event => {
          event.target.closest('.kinahh-video-edit__card')?.scrollIntoView({ behavior: 'instant', block: 'nearest', inline: 'nearest' });
        }, { signal });
        this.visibility = new IntersectionObserver(entries => entries.forEach(entry => {
          if (entry.intersectionRatio < .35) this.pause(entry.target.closest('.kinahh-video-edit__card'));
        }), { threshold: [.35] });
        this.cards.forEach(card => this.visibility.observe(card.querySelector('.kinahh-video-edit__media')));
        this.resize = new ResizeObserver(this.update);
        this.resize.observe(this.list);
        this.update();
      }
      scrollPosition() {
        const maximum = Math.max(0, this.list.scrollWidth - this.list.clientWidth);
        const direction = getComputedStyle(this.list).direction === 'rtl' ? -1 : 1;
        // Safari can report elastic overscroll outside either end of the list.
        const current = Math.min(maximum, Math.max(0, this.list.scrollLeft * direction));
        return { maximum, current, direction };
      }
      pause(card) {
        card.playRequest = (card.playRequest || 0) + 1;
        card.wantsPlayback = false;
        card.querySelector('video').pause();
        card.removeAttribute('data-playing');
        const button = card.querySelector('.kinahh-video-edit__play');
        button.setAttribute('aria-label', button.dataset.playLabel);
      }
      disconnectedCallback() {
        this.cards?.forEach(card => this.pause(card));
        this.controller?.abort();
        this.visibility?.disconnect();
        this.resize?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
